/* eslint-disable indent */
import { FC, memo } from 'react'
import { createIcon, IconProps } from '@chakra-ui/icons'
import { Box } from '@chakra-ui/react'

import CustomIcon from '../../CustomIcon'

interface CustomIconProps extends IconProps {
  variant?: string
  color?: string
}

const HandWithHeartIconOutline = createIcon({
  displayName: 'HandWithHeartIconOutline',
  viewBox: '0 0 24 24',
  path: (
    <>
      <g fill="none">
        <path d="M0,0h24v24h-24Z"></path>
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M5.984,21h-1.984c-0.552,0 -1,-0.448 -1,-1v-6c0,-0.552 0.448,-1 1,-1h1.984c0.552,0 1,0.448 1,1v6c0,0.552 -0.448,1 -1,1Z"
        ></path>
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M12.96,17h2.324c0.431,0 0.85,-0.14 1.195,-0.4l2.406,-1.812c0.601,-0.452 1.441,-0.392 1.972,0.141v0c0.589,0.592 0.589,1.551 0,2.142l-2.064,2.073c-0.556,0.558 -1.264,0.939 -2.036,1.094l-2.919,0.586c-0.578,0.116 -1.175,0.102 -1.748,-0.042l-2.639,-0.662c-0.315,-0.08 -0.64,-0.12 -0.966,-0.12h-1.501"
        ></path>
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M12.96,17h1.479c0.833,0 1.509,-0.678 1.509,-1.515v-0.303c0,-0.695 -0.471,-1.301 -1.143,-1.469l-2.283,-0.573c-0.371,-0.093 -0.752,-0.14 -1.134,-0.14v0c-0.923,0 -1.826,0.274 -2.594,0.789l-1.81,1.211"
        ></path>
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M15.286,3.661l-0.349,0.373l-0.35,-0.373c-0.767,-0.818 -2.039,-0.885 -2.887,-0.153v0c-0.867,0.748 -0.97,2.045 -0.257,2.943c1.02,1.284 2.189,2.552 3.494,3.549c1.338,-1.022 2.532,-2.328 3.57,-3.645c0.674,-0.855 0.535,-2.096 -0.287,-2.807l-0.038,-0.033c-0.856,-0.739 -2.129,-0.672 -2.896,0.146Z"
        ></path>
      </g>
    </>
  ),
})

const HandWithHeartIconTwoTone = createIcon({
  displayName: 'HandWithHeartIconTwoTone',
  viewBox: '0 0 24 24',
  path: (
    <>
      <g fill="none">
        <Box as="path" d="M0,0h24v24h-24Z"></Box>
        <Box
          as="path"
          stroke="twoToneStrokeColor"
          fill="twoToneFillColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M5.984,21h-1.984c-0.552,0 -1,-0.448 -1,-1v-6c0,-0.552 0.448,-1 1,-1h1.984c0.552,0 1,0.448 1,1v6c0,0.552 -0.448,1 -1,1Z"
        ></Box>
        <Box
          as="path"
          stroke="twoToneStrokeColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M12.96,17h2.324c0.431,0 0.85,-0.14 1.195,-0.4l2.406,-1.812c0.601,-0.452 1.441,-0.392 1.972,0.141v0c0.589,0.592 0.589,1.551 0,2.142l-2.064,2.073c-0.556,0.558 -1.264,0.939 -2.036,1.094l-2.919,0.586c-0.578,0.116 -1.175,0.102 -1.748,-0.042l-2.639,-0.662c-0.315,-0.08 -0.64,-0.12 -0.966,-0.12h-1.501"
        ></Box>
        <Box
          as="path"
          stroke="twoToneStrokeColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M12.96,17h1.479c0.833,0 1.509,-0.678 1.509,-1.515v-0.303c0,-0.695 -0.471,-1.301 -1.143,-1.469l-2.283,-0.573c-0.371,-0.093 -0.752,-0.14 -1.134,-0.14v0c-0.923,0 -1.826,0.274 -2.594,0.789l-1.81,1.211"
        ></Box>
        <Box
          as="path"
          stroke="twoToneStrokeColor"
          fill="twoToneLightColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M15.286,3.661l-0.349,0.373l-0.35,-0.373c-0.767,-0.818 -2.039,-0.885 -2.887,-0.153v0c-0.867,0.748 -0.97,2.045 -0.257,2.943c1.02,1.284 2.189,2.552 3.494,3.549c1.338,-1.022 2.532,-2.328 3.57,-3.645c0.674,-0.855 0.535,-2.096 -0.287,-2.807l-0.038,-0.033c-0.856,-0.739 -2.129,-0.672 -2.896,0.146Z"
        ></Box>
      </g>
    </>
  ),
})

const HandWithHeart: FC<CustomIconProps> = (props) => {
  switch (props.variant || 'outline') {
    case 'twoTone':
      return <CustomIcon as={HandWithHeartIconTwoTone} {...props} />
    default:
      return <CustomIcon as={HandWithHeartIconOutline} {...props} />
  }
}

export default memo(HandWithHeart)
